export default "__VITE_ASSET__BHIA7PnU__"